import { GetMeResponse } from 'api-schema'
import { createContext } from 'react'

type UserContextType = {
  user: GetMeResponse['data']['user'] | null
}

export const UserContext = createContext<UserContextType>({ user: null })
